const cartCTA = document.querySelector('.cart-items-page__section-select');
//Fixed position bar
if (cartCTA) {
  const offset = cartCTA.offsetTop;
  const rect = cartCTA.getBoundingClientRect();
  const scrollUp = 'scroll-up';
  const scrollDown = 'scroll-down';
  let lastScroll = 0;
  // Create the function to be called on scroll
  const stick = function() {
    // Get the scroll
    let scroll = window.scrollY;
    if (scroll >= 90) {
      cartCTA.classList.add('stick');
    } else if (scroll <= 90) {
      cartCTA.classList.remove('stick');
    }
    
    if (scroll <= 90) {
      cartCTA.classList.remove(scrollUp);
      cartCTA.classList.remove(scrollDown);
      return;
    }

    if (scroll > lastScroll && !cartCTA.classList.contains(scrollDown)) {
      // down
      cartCTA.classList.remove(scrollUp);
      cartCTA.classList.add(scrollDown);
    } else if (scroll < lastScroll && cartCTA.classList.contains(scrollDown)) {
      // up
      cartCTA.classList.remove(scrollDown);
      cartCTA.classList.add(scrollUp);
    }
    lastScroll = scroll;
  };
  // listen to the scroll
  window.addEventListener('scroll', stick);
}


